function quickCart(){

    "use strict";

    var QUICK_CARTLAUNCH = '.quick-cart__launch',
        QUICK_CART = '#quick-cart';

    $('body').click(function(e) {
        if ($(this).hasClass('cart-open')) {
            $(QUICK_CART).removeClass('quick-cart__open');
            $(this).removeClass('cart-open');
        }
    });

    $( QUICK_CARTLAUNCH ).on('click', onClick);

    function onClick(event) {
        event.preventDefault();
        $(QUICK_CART).toggleClass('quick-cart__open');
        $('body').toggleClass('cart-open');
        return false;
    }

}

module.exports = quickCart;


// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/components/global/12_quick-cart.js